// removed by extract-text-webpack-plugin
module.exports = {"normal":"_3GZOgvyH_agP_L2Jtw93BZ","insideForm":"vNXaaR0I46m-c9ylNyx0v","closeLabel":"_1jwaM2SLjYYV5nNe88CZjQ"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/RemoveButton.scss
// module id = 1239
// module chunks = 0